'use client';

import { useTranslations, useLocale } from 'next-intl';
import { useSuspenseQuery } from '@apollo/client';

import { MenuItemsQuery } from '@/query';

import { HeaderContent } from './Header/HeaderContent';
import Footer from './Footer/Footer';

export const Layout = ({ children }) => {
  const t = useTranslations();
  const locale = useLocale();

  const { data } = useSuspenseQuery(MenuItemsQuery, {
    variables: { locale },
    errorPolicy: 'ignore',
  });

  return (
    <div id="page">
      <HeaderContent menuItems={data?.menuItems} />
      <main>{children}</main>
      <Footer menuItems={data?.menuItems} />
    </div>
  );
};
